<template>
  <div class="footer__wrapper">
    <div class="footer__container">
      <!-- logo and copyright -->
      <div class="logo__copy__container">
        <img class="logo" src="@/assets/footer_logo.png" alt="logo" />
        <div class="para__wrapper">
          <p>NEURALINK CLONE</p>
          <p>BY CODE-REAPER08</p>
        </div>
      </div>
      <!-- Menu -->
      <div class="menu__container">
        <a href="#" class="list__items">SCIENCE</a>
        <a href="#" class="list__items">APPROACH</a>
        <a href="#" class="list__items">APPLICATIONS</a>
        <a href="#" class="list__items">ABOUT US</a>
        <a href="#" class="list__items">CAREERS</a>
        <a href="#" class="list__items">BLOG</a>
      </div>
      <!-- Form controls -->
      <div class="formcontrol__container">
        <div class="mail__socials">
          <a href="#">INFO@NEURALINK.COM</a>
          <a href="#">@NEURALINK</a>
        </div>
        <div class="input__container">
          <input
            class="input__box"
            type="text"
            placeholder="ENTER EMAIL FOR UPDATES"
          />
          <!-- arrow icon -->
          <div class="arrow__container">
            <img
              class="right__arrow"
              src="../assets/right-arrow.png"
              alt="icon"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
/* Laptop responsive code */
@media only screen and (min-width: 601px) {
  .footer__wrapper {
    padding: 3.5rem;
    background-color: #f2f7f7;
  }
  .footer__container {
    display: grid;
    grid-template-columns: 3fr 1fr 2fr;
  }
  .logo__copy__container {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .logo {
    margin-right: 3.5rem;
  }
  .para__wrapper > p {
    font-family: "Barlow", sans-serif;
    font-size: 14px;
    line-height: 20px;
    margin: 0;
    font-weight: bolder;
    color: #858686;
  }
  .menu__container {
    display: flex;
    flex-direction: column;
  }
  .list__items {
    text-align: start;
    color: #858686;
    font-size: 14px;
    line-height: 15pt;
    font-weight: bolder;
    font-family: "Barlow", sans-serif;
    transition: 2ms ease-in-out;
  }
  .list__items:hover {
    color: black;
  }
  .mail__socials {
    display: flex;
    text-align: start;
    flex-direction: column;
  }
  .mail__socials > a {
    color: #858686;
    font-family: "Barlow", sans-serif;
    line-height: 15pt;
    font-size: 15px;
    font-weight: bolder;
    transition: 2ms ease-in-out;
  }
  .mail__socials > a:hover {
    color: black;
  }
  .input__container {
    display: flex;
  }
  .input__box {
    margin-top: 1rem;
    width: 100%;
    height: 2rem;
    border: none;
    background-color: transparent;
    resize: none;
    outline: none;
    border-bottom: 1px solid black;
  }
  .input__box::placeholder {
    color: #858686;
  }
  .formcontrol__container {
    text-align: start;
  }
  .right__arrow {
    margin-top: 25px;
    margin-left: -15px;
    position: absolute;
    width: 15px;
    height: 20px;
    opacity: 0.3;
    cursor: pointer;
    /* filter: invert(100); */
  }
}
/* Mobile responsive code */
@media only screen and (max-width: 600px) {
  .footer__wrapper {
    padding-top: 1.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-bottom: 6.5rem;
    background-color: #f2f7f7;
  }
  .footer__container {
    display: grid;
    /* grid-template-columns: 3fr 1fr 2fr; */
  }
  .logo__copy__container {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .logo {
    margin-right: 7.5rem;
    width: 50px;
    height: 32px;
  }
  .para__wrapper > p {
    font-family: "Barlow", sans-serif;
    font-size: 14px;
    line-height: 20px;
    margin: 0;
    font-weight: bolder;
    color: #858686;
  }
  .menu__container {
    display: none;
    /* display: flex; */
    flex-direction: column;
  }
  .list__items {
    text-align: start;
    color: #858686;
    font-size: 14px;
    line-height: 15pt;
    font-weight: bolder;
    font-family: "Barlow", sans-serif;
    transition: 2ms ease-in-out;
  }
  .list__items:hover {
    color: black;
  }
  .mail__socials {
    display: flex;
    text-align: start;
    flex-direction: column;
  }
  .mail__socials > a {
    color: #858686;
    font-family: "Barlow", sans-serif;
    line-height: 15pt;
    font-size: 15px;
    font-weight: bolder;
    transition: 2ms ease-in-out;
  }
  .mail__socials > a:hover {
    color: black;
  }
  .input__container {
    display: flex;
  }
  .input__box {
    margin-top: 1rem;
    width: 100%;
    height: 2rem;
    border: none;
    background-color: transparent;
    resize: none;
    outline: none;
    border-bottom: 1px solid black;
  }
  .input__box::placeholder {
    color: #858686;
  }
  .formcontrol__container {
    display: none;
    text-align: start;
  }
  .right__arrow {
    margin-top: 25px;
    margin-left: -15px;
    position: absolute;
    width: 15px;
    height: 20px;
    opacity: 0.3;
    cursor: pointer;
    /* filter: invert(100); */
  }
}
</style>
